exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-disabled-tab[data-v-3dda426a] {\n  color: #84919a;\n  background-color: transparent;\n  border-color: transparent;\n}\n", ""]);

// exports
